import {defineStore} from 'pinia'

export const useProfilesApplicationStore = defineStore('profilesApplicationStore', {
    state: () => {
        return {
            isEnabled: true,
        }
    },
    actions: {},
})
